import { AttributeModel } from "src/models";

export const checkIfAttributeIsCustom = (attribute: AttributeModel) =>
  attribute.kind === "custom" && attribute.name !== "productType";
